import { useParams } from "react-router-dom";
import { ProjectPage } from "@/app/components/projects/ProjectPage";

export default function ProjectDetailPage() {
    const { id } = useParams<{ id: string }>();
    if (!id) return null;
    return <ProjectPage projectId={id} />;
}
